export default __webpack_public_path__ + "static/media/menu-icon-transactions.9ac6b7bb.svg";